<template>
  <header class="marketing-email-header-create">
    <v-stepper class="marketing-email-header-create-steps"
               :value="step"
               alt-labels
               @input="emitInput">
      <v-stepper-header>
        <v-stepper-step :step="1"
                        :complete="step > 1">
          {{$t('message.marketingGenerics.message.template')}}
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :step="2"
                        :complete="step > 2"
                        :edit-icon="$vuetify.icons.complete"
                        :editable="step > 1"
                        @click="goToContentStep(step > 1)">
            {{$t('message.marketingGenerics.message.content')}}
        </v-stepper-step>

        <v-divider v-if="!isAutomationFlow"></v-divider>

        <v-stepper-step v-if="!isAutomationFlow"
                        :step="3"
                        :complete="step > 3"
                        :edit-icon="$vuetify.icons.complete"
                        :editable="step > 1"
                        @click="goToSendersStep(step > 1)">
            {{$t('message.marketingGenerics.message.recipients')}}
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :step="isAutomationFlow ? 3 : 4"
                        :complete="isAutomationFlow ? step > 3 :step > 4">
            {{$t('message.marketingGenerics.message.verification')}}
        </v-stepper-step>

        <v-divider v-if="!isAutomationFlow"></v-divider>

        <v-stepper-step v-if="!isAutomationFlow"
                        :step="5"
                        :complete="step > 5">
            {{$t('message.marketingGenerics.message.send')}}
        </v-stepper-step>
      </v-stepper-header>
    </v-stepper>

    <div v-if="isContentStep"
         class="marketing-email-header-create-content">

      <div class="marketing-email-header-create-content-saving">
        <i class="mdi mdi-content-save-outline"
           :class="{ 'cursor-wait': isContentSaving }"></i>

        <p class="text-bold marketing-email-header-create-content-saving-text">
          {{ isContentSaving ?  this.$t('message.marketingGenerics.message.saving') : this.$t('message.marketingGenerics.message.saved') }}
        </p>
      </div>

      <button v-if="isStripoEditor || isHtmlEditor"
              class="btn btn-primary btn-extra-round"
              @click="emitSaveContent">
          {{$t('message.generics.message.advance')}}
      </button>
    </div>
  </header>
</template>

<script>
import EventBus from "@packages/event-bus/index";

export default {
  props: {},

  components: {},

  created() {
    const step = Number(sessionStorage.getItem("email_step"))
    step ? this.$store.commit("SET_EMAIL_CREATE_STEP", step) : this.$store.commit("SET_EMAIL_CREATE_STEP", 1);
    this.$store.commit("EMAIL_CREATE_SET_ITEM", undefined);
  },

  computed: {
    step() {
      return this.stepInSessionStorage ? this.stepInSessionStorage : this.$store.state.marketing.email.create.step;
    },
    isStripoEditor() {
      return this.$store.state.marketing.email.create.data.model.editorType ?
      this.$store.state.marketing.email.create.data.model.editorType === "STRIPO" :
      this.dataInSessionStorage.model.editorType === "STRIPO"; 
    },
    isHtmlEditor() {
      return this.$store.state.marketing.email.create.data.model.editorType ?
      this.$store.state.marketing.email.create.data.model.editorType === "HTML" :
      this.dataInSessionStorage.model.editorType === "HTML";      
    },       
    dataInSessionStorage() {
      return JSON.parse(sessionStorage.getItem("email_data"));     
    },
    itemInSessionStorage() {
      return JSON.parse(sessionStorage.getItem("email_item"));     
    },
    stepInSessionStorage() {
      return Number(sessionStorage.getItem("email_step"));     
    },
    isAutomationFlow() {
      return this.$store.state.marketing.email.create.data.title ?
      this.$store.state.marketing.email.create.data.isAutomationFlow :
      this.dataInSessionStorage.isAutomationFlow
    },
    isContentStep() {
      return Number(this.step) === 2;
    },
    isContentSaving() {
      return this.$store.state.marketing.email.isContentSaving;
    },
  },

  data() {
    return {};
  },

  methods: {
    emitInput(newStepVal) {
      this.$store.commit("SET_EMAIL_CREATE_STEP", newStepVal);
    },
    emitSaveContent() {
      EventBus.$emit("EMAIL_CREATE_NEXT_STEP");
    },
    goToContentStep(isEditable) {
      if (isEditable) {
        this.$router.push({
          path: `/marketing/email/criar/conteudo`,
        });
        sessionStorage.setItem("email_step", 2);
      }
    },
    goToSendersStep(isEditable) {
      if (isEditable) {
        this.$router.push({
          path: `/marketing/email/criar/destinatarios`,
        });
        sessionStorage.setItem("email_step", 3);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.marketing-email-header-create {
  display: flex;
  align-items: center;

  .marketing-email-header-create-steps {
    flex: 1;
    box-shadow: none;

    .v-stepper__header {
      padding: 0 30px;
      
    }
  }

  .marketing-email-header-create-content {
    display: flex;
    align-items: center;

    .marketing-email-header-create-content-saving {
      display: flex;
      align-items: center;
      color: $grey-4;
      min-width: 135px;
      margin-right: 10px;

      .marketing-email-header-create-content-saving-text {
        margin: 0;
      }

      .mdi {
        font-size: 26px;
        padding: 0 5px;

        &:last-child {
          padding: 0 30px 0 10px;
        }
      }
    }
  }  
}

@media only screen and (max-width: 1400px) {
  
  .v-stepper__step {   
    flex: 0 1 80px;
    padding: 0;
    padding-top: 22px;
    align-self: center;
    width: 80px;
    
    ::v-deep .v-stepper__label {
      visibility: hidden;    
      
    }
    ::v-deep .v-stepper__step__step:hover + .v-stepper__label {
      visibility: visible;    
      
    }        
  }  
  .v-divider {
    margin: 35px -20px 0 !important;
  }
}
</style>

